import {FeaturesEnum} from 'presentation/constants';
import {useGetHealthCardQuery} from 'presentation/pages/private/health-card/queries/useGetHealthCardQuery';
import {useFeatureFlagsQuery} from 'presentation/queries/useFeatureFlagsQuery';

import {useHostName} from '../useHostName';

export const getSaludiaFeatureFlagName = (cdModeloCarteira: string) =>
	`${FeaturesEnum.PORTAL_FEATURE_EXP_SALUDIA_BY_PLAN}_${cdModeloCarteira}`;

export const useSaludiaExperience = () => {
	const {isNotredameSaude} = useHostName();
	const {data: featureFlags} = useFeatureFlagsQuery();
	const {data: healthCard} = useGetHealthCardQuery({enabled: isNotredameSaude});

	const cdModeloCarteira = healthCard?.cdModeloCarteira;

	const isFlagEnabled =
		!!cdModeloCarteira &&
		!!featureFlags?.find(({flag}) => flag === getSaludiaFeatureFlagName(cdModeloCarteira))
			?.enabled;

	return {
		isSaludiaEnabled: isNotredameSaude && isFlagEnabled,
		cardCode: healthCard?.cdUsuarioC ?? '',
	};
};

export {SALUDIA_URLS} from './constants';
